// Função utilitária para aplicar filtro de array de IDs válidos
export const applyArrayFilter = (params, array, paramName) => {
  if (array && array.length > 0 && array.some(id => id && id !== 0)) {
    params[paramName] = array.filter(id => id && id !== 0);
  }
};
